import { NgModule } from '@angular/core';
import { ProductRecommendationsStoreModule } from './store/product-recommendations-store.module';

@NgModule({
  imports: [ProductRecommendationsStoreModule],
})
export class ProductDataAccessModule {}
